import { SUPPORTED_LOCALES } from './constants';

export function getSelectedLocale(selectedLocale: string | null) {
  return (
    SUPPORTED_LOCALES.find((locale) => locale === selectedLocale) ??
    SUPPORTED_LOCALES.find(
      (locale) => locale.split('-')[0] === selectedLocale?.split('-')[0],
    )
  );
}
